<template>
  <div class="main-wrapper">
    <img src="../assets/alert.png" alt="Внимание!" height="150px" />
    <p>
      Внимание! Приложение работает в тестовом режиме!
    </p>
  </div>
</template>

<script>
export default {
  name: "AppInTestMode",
};
</script>

<style scoped></style>
